module.exports = __webpack_public_path__ + "img/icons_solid.feba727f.svg";